import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { IconFaInstagram, IconFaFacebookSquare, IconFaYoutube } from './style';
import LoadScreen from '../../components/loadScreen/loadScreen';
import Login from '../login/Login';
import PageLogin from '../../pages/loginPage/loginPage';
import {
    DivPrincipal,
    DivTop,
    DivAcesso,
    DivButtonAcessar,
    DivCorpo,
    DivElementos,
    DivPreco,
    DivRodape,
    CorpoRodape,
    DivRedeSocial,
    RedesSociais,
    CopyRigth,
    DivImageTextoBannerTop,
    DivExperimente,
} from './style';



export default function Index({ acao }) {
    const history = useHistory();
    const [displayLoad, setDisplayLoad] = useState('none');
    const [objLogin, setObjLogin] = useState({});
    const [redirect, setRedirect] = useState(false)
    const Logo = require('../../assets/images/logo_200_social.jpg').default;
    const Social1 = require('../../assets/images/social6.jpeg').default;
    const Social2 = require('../../assets/images/social21.jpeg').default;
    const Social3 = require('../../assets/images/social31.jpeg').default;
    const Social5 = require('../../assets/images/social52.jpeg').default;
    const Social4 = require('../../assets/images/medx-social-13.png').default;
    const Social6 = require('../../assets/images/social12.jpg').default;
    const Social1Mobile = require('../../assets/images/social51.jpeg').default;
    const Investimento = require('../../assets/images/medx-social-14.png').default;

    function autologin() {
        setRedirect(true);
        // setTimeout(() => {
        //     function getStatusFacebook(objResponseFacebookStatus){
        //         console.log(objResponseFacebookStatus)
        //         if(objResponseFacebookStatus.status === "connected"){
        //             setObjLogin(objResponseFacebookStatus);
        //             setDisplayLoad('none')
        //         }else{
        //             setDisplayLoad('none')
        //             console.log(objResponseFacebookStatus)
        //         }
        //     }
        //     window.FB.getLoginStatus(getStatusFacebook);

        // }, 300);
    }

    useEffect(() => {
        if (history.location.pathname === '/redirect')
            autologin()
    }, [])

    return (!redirect ?
        <DivPrincipal>
            <DivElementos>
                <DivAcesso >
                    <div>
                        <img style={{ width: '115px' }} src={Logo} />
                    </div>
                    <DivButtonAcessar>
                        <Login login={objLogin} txtbutton='Entrar' />
                    </DivButtonAcessar>
                </DivAcesso>
                <DivTop>
                    <DivImageTextoBannerTop>
                        <img style={{ width: '100%', height: '100%' }} src={window.screen.width > 800 ? Social5 : Social1Mobile} />
                    </DivImageTextoBannerTop>
                    <div style={{ position: 'absolute', top: '71%', right: '140px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    </div>
                </DivTop>
                <DivExperimente>
                    <h2>Experimente gratuitamente por 7 dias, com 1 post por dia.</h2>
                    {displayLoad === 'flex' ? '' : <Login acao={acao} width={'fit-content'} txtbutton='Quero Experimentar' />}
                </DivExperimente>
                <DivCorpo>
                    <div>
                        <img src={Social1} />
                    </div>
                    <div>
                        <h2>Conteúdo atualizado e de qualidade</h2>
                        <p>O MEDX.Social é um serviço que traz pra você centenas de conteúdos para postar nas suas redes sociais todos os meses, com assuntos relacionados a medicina, nutrição e atividade física - utilizando como fonte os principais periódicos da área médica, de nutrição e de fisiologia do exercício. Todo conteúdo é simplificado, em linguagem acessível para o público leigo e em formato de textos curtos (de três a quatro parágrafos).</p>
                    </div>
                </DivCorpo>
                <DivCorpo inverter={window.screen.width > 800}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img style={{ maxWidth: '320px' }} src={Social4} />
                    </div>
                    <div>
                        <h2>Site automático com layout responsivo</h2>
                        <p>Selecionando as postagens para uso, o MEDX.Social gera automaticamente um site com 3 páginas para seu consultório ou clínica, além de um blog com os conteúdos já desbloqueados. Você fica com um endereço personalizado pra esse site, pode integrar com Google Analytics e o site tem layout responsivo (adaptado para uso em smartphones), de forma automática.</p>
                    </div>
                </DivCorpo>
                <DivCorpo>
                    <div>
                        <img src={Social6} />
                    </div>
                    <div>
                        <h2>Compartilhe com facilidade</h2>
                        <p>Você pode compartilhar qualquer conteúdo do MEDX.Social de maneira simples e rápida. Basta escolher o modelo de post, alterar qualquer conteúdo se você quiser (como título, foto e até o próprio texto) e selecionar o botão da rede social em que você quer compartilhar.</p>
                    </div>
                </DivCorpo>
                <DivCorpo inverter={window.screen.width > 800}>
                    <div>
                        <img src={Social2} />
                    </div>
                    <div>
                        <h2>Tenha maior engajamento, tudo em conformidade<br /> com código de ética médica</h2>
                        <p>Aumente o engajamento nas suas redes sociais com maior frequência de postagens usando os conteúdos já prontos do MEDX SOCIAL. Os modelos de posts já estão em conformidade com o que pede a resolução do CFM, como a referência científica relacionada ao conteúdo ou a fonte da publicação. Além de ter adequação a resolução de publicidade médica vigente, o formato de postagem traz credibilidade as suas postagens.</p>
                    </div>
                </DivCorpo>
                <DivCorpo>
                    <div>
                        <img src={Social3} />
                    </div>
                    <div>
                        <h2>Novos conteúdos todo mês</h2>
                        <p>O MEDX.Social traz um banco de dados com centenas de postagens prontas para você utilizar e novos conteúdos são adicionados todo mês. É a maneira mais fácil de você ter conteúdo atualizado e relevante para uso em suas redes sociais.</p>
                    </div>
                </DivCorpo>
                <DivPreco>
                    <img src={Investimento} alt='preço' />
                    <div style={{ margin: '20px 0' }}>{displayLoad === 'flex' ? '' : <Login acao={acao} txtbutton='Quero experimentar' />}</div>
                </DivPreco>
            </DivElementos>
            <DivRodape>
                <CorpoRodape>
                    <div>
                        <h1>Sobre o MEDX.Social</h1>
                        <p>O MEDX.Social é uma plataforma de conteúdo de saúde para uso em redes sociais e marketing digital por médicos, nutricionistas e profissionais de educação física. É uma solução da MEDX Soluções Tecnológicas, desenvolvedora da plataforma de gestão de consultórios e clínicas MEDX.</p>
                    </div>
                    <div>
                        <h1>Redes Sociais</h1>
                        <RedesSociais>
                            <DivRedeSocial><a href="https://www.facebook.com/MEDXBRASIL" target='_blank'><IconFaInstagram /></a></DivRedeSocial>
                            <DivRedeSocial><a href="http://www.instagram.com/medxbrasil" target='_blank'><IconFaFacebookSquare /></a></DivRedeSocial>
                            <DivRedeSocial><a href='https://www.youtube.com/c/MEDXBRASIl/videos' target='_blank'><IconFaYoutube /></a></DivRedeSocial>
                        </RedesSociais>
                    </div>
                    <CopyRigth>
                        © 2005-2021 MEDX Soluções Tecnológicas Ltda.<br />
                        Todos os direitos reservados.
                    </CopyRigth>
                </CorpoRodape>

            </DivRodape>

        </DivPrincipal>
        : <>
            <PageLogin login={objLogin} />
            <LoadScreen display={displayLoad} /></>
    );
}
